import React, { useState, useContext } from 'react';

import { useNavigate } from 'react-router-dom';

const CreatePosts = () => {

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [message, setMessage] = useState('');

    const navigate = useNavigate();

    const goToPosts = () => {
        navigate('/posts');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('http://127.0.0.1:8000/posts', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                
                },
                body: JSON.stringify({
                    title,
                    content
                })
            });

            if (response.ok) {
                setMessage('Post created successfully!');
            } else {
                setMessage('Failed to create post');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <div className="CreatePosts">
            <form onSubmit={handleSubmit}>
                <label htmlFor="title">Title:</label>
                <input
                    type="text"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />

                <label htmlFor="content">Content:</label>
                <textarea
                    id="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                />

                <button type="submit">Submit</button>
            </form>
            {message && <p>{message}</p>}
            <button onClick={goToPosts}></button>
        </div>
    );
};

export default CreatePosts;
